export default {
  getAssignmentById: '/assignment/getAssignmentById',
  getAssignmentsOfADivisionOfASubject: '/assignment/getAssignmentsOfADivisionOfASubject',
  getAssignmentsOfACourseYear: '/assignment/getAssignmentsOfACourseYear'
}
